import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService, UserService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PropertyService } from '@app/_components/property/property.service';
import { OwnerLeadProfileService } from '../owner-lead-profile.service';
import { OwnerLeadProfile } from '../owner-lead-profile';
import { PropertyLeadProfileService } from '@app/_components/property-lead-profile/property-lead-profile.service';
import { PropertyLeadProfileComponent } from '@app/_components/property-lead-profile/property-lead-profile/property-lead-profile.component';
import { PropertyLeadProfile } from '@app/_components/property-lead-profile/property-lead-profile';
import { UserTitles } from '@app/_helpers/constants';
import { RealtorProfileService } from '@app/_components/realtor-profile/realtor-profile.service';
import { RealtorProfileComponent } from '@app/_components/realtor-profile/realtor-profile/realtor-profile.component';
import { RealtorProfile } from '@app/_components/realtor-profile/realtor-profile';
import { first, take } from 'rxjs';
import { OwnerPropertyComponent } from '../owner-property-details/owner-property-details.component';
import { ActivatedRoute } from '@angular/router';
import { TravelAgentProfileService } from '@app/_components/travel-agent-profile/travel-agent-profile.service';
import { NotesChatConfig } from '@app/_components/_shared/notes-chat/notes-chat.component';

@Component({
    selector: 'app-owner-lead-profile',
    templateUrl: './owner-lead-profile.component.html',
    styleUrls: ['./owner-lead-profile.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OwnerLeadProfileComponent implements OnInit {

	properties: any;
	users: any;
	propertyLeadProfilesList: any;
	isDisplayPropertyProfile: boolean = true;
	titles !: any;
	assignedToUserId;
	countries: any;
	states: any;
	realtorProfilesList: any;
	leadStatuses: { name: string; value: number; }[];
	probabilitiesList: { name: string; value: number; }[];
	opportunityProbs: { name: string; value: number; }[];
	winReasons: any[];
	lossReasons: any[];
	currentUser: any;
	isAgent1 = false;
	isAgent2 = false;
	isAgent3 = false;
	isAgent4 = false;
	manager = false;
	isManager = false;
	errorList: any[] = [];
	errorMessages: string;
	showValidationErrors = false;
	showValidationError = false;
	ownershipCompanies: any[] = [];
	ownershipInterests: any[] = [];
	filteredNames: any;
	percentages: any;
	compNegReasons = [
		{ name: 'Price', value: 1 },
		{ name: 'Poor Income', value: 2 },
		{ name: 'Housekeeping', value: 3 },
		{ name: 'Maintance', value: 4 },
		{ name: 'Owner services', value: 5 },
		{ name: 'Other', value: 6 }
	];

	notesChatConfig: NotesChatConfig = {
		title: 'Owner Lead Profile Notes',
		maxWidth: '100%',
		maxHeight: '250px',
		customClass: '',
		fieldsPosition: 'top',
		showFilters: true,
		showSortOptions: false,
		fillParent: false,
		sortByDate: 'desc',
		allowEdit: true,
		allowDelete: false,
		allowAdd: true,
		emptyNotesText: 'No notes added',
		placeholder: 'Enter remarks',
		theme: 'default',
		maxNoteLength: 150,
		editButtonText: 'Edit Note',
		deleteButtonText: 'Delete Note',
		cancelButtonText: 'Cancel',
		noteTypes: [
			{ value: 1, name: 'General', color: '#DCDCDC' },
			{ value: 2, name: 'Action Item', color: '#ffcccc' },
			{ value: 4, name: 'Meeting Notes', color: '#ade061' },
			{ value: 5, name: 'Status Update', color: '#FFFF99' }
		],
		statusOptions: [
			{ value: 0, name: 'Open', color: '#D3D3D3' },
			{ value: 1, name: 'Complete', color: '#90EE90' },
			{ value: 2, name: 'Proposed', color: '#FFE599' },
			{ value: 3, name: 'On Hold', color: '#ADD8E6' },
			{ value: 4, name: 'Cancelled', color: '#F4A6A6' },
			{ value: 5, name: 'In Progress', color: '#FFA500' }
		]
	};

	constructor(
		private constantService: ConstantService,
		private travelAgentProfileService: TravelAgentProfileService,
		private propertyService: PropertyService,
		private primengConfig: PrimeNGConfig,
		private ownerLeadProfileService: OwnerLeadProfileService,
		private alertService: AlertService,
		private dialog: MatDialog,
		private propertyLeadProfileService: PropertyLeadProfileService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: FormBuilder,
		private userService: UserService,
		private activatedRoute: ActivatedRoute,
		private realtorProfileService: RealtorProfileService,
		@Optional() private dialogRef: MatDialogRef<OwnerLeadProfileComponent>,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.isDisplayPropertyProfile = data.isDisplayPropertyProfile == false ? false : true,
			this.ownerLeadProfile = data.ownerLeadProfile,
			this.ownerLeadProfileId = data.ownerLeadProfile?.ownerLeadProfileId;
		this.titles = UserTitles;
		this.countries = this.constantService.countries;
		this.states = this.constantService.states;
		this.leadStatuses = this.ownerLeadProfileService.leadStatuses;
		this.probabilitiesList = this.ownerLeadProfileService.probabilitiesList;
		this.winReasons = this.ownerLeadProfileService.winReasons;
		this.lossReasons = this.ownerLeadProfileService.lossReasons;
		this.ownershipCompanies = this.ownerLeadProfileService.ownershipCompanies; // fallback; overwritten in ngOnInit
		this.ownershipInterests = this.ownerLeadProfileService.ownershipInterests;
		this.percentages = travelAgentProfileService.percentages;
	}

	@Input() ownerLeadProfile: OwnerLeadProfile;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	ownerLeadProfileId: number;
	propertyLeadProfileObj: PropertyLeadProfile[] = [];
	realtorProfileObj: RealtorProfile[] = [];
	tags;
	taskUserSuggestions: string[];

	// forms
	form1: FormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'ownerLeadProfileId': [],
		'firstName': [{ type: 'required', message: 'First Name Required' }],
		'lastName': [{ type: 'required', message: 'Last Name Required' }],
		'emailAddress': [],
		'mobilePhone': [],
		subjAdrStreet: [],
		subjAdrStreet2: [],
		subjAdrCity: [],
		subjAdrState: [],
		subjAdrPostalCode: [],
		subjAdrDevelopmentName: [],
		mailAdrStreet: [],
		mailAdrStreet2: [],
		mailAdrCity: [],
		mailAdrState: [],
		mailAdrPostalCode: [],
		// mailAdrCountry: [],
		leadStatus: [],
		probability: [],
		ownershipInterest: [],
		winReason: [],
		lossReason: [],
		assignToSalesAgnt1: [],
		assignToSalesAgnt2: [],
		assignToSalesAgnt3: [],
		subjAdrLocationDesc: [],
		customerNotes: [],
		ownershipStatus: [],
		fullName: [],
		emailAddress2: [],
		phone2: [],
		mailAdrLocationDesc: [],
		compName: [],
		compNegReason: [],
		compNegDesc: [],
		compPosDesc: [],
		compContractExpDate: [],
		compMgmtFee: [],
		currentGrossRev: [],
		propertyLeadProfiles:[]
	};
	leadProfileAge: string;
	ngOnInit() {
		this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
		// this.fetchProperties();
		this.fetchRealtorProfiles();
		// this.fetchPropertyLeadProfiles()
		this.fetchUsers();
		this.primengConfig.ripple = true;
		this.formBuild();
		this.ownerLeadProfileService.getCompetitors().subscribe(list => {
			this.ownershipCompanies = list;
		});

		// if we were passed the whole ownerLeadProfile object
		if (this.ownerLeadProfile) {
			this.ownerLeadProfileId = this.ownerLeadProfile.ownerLeadProfileId;
			if (this.ownerLeadProfile.assignToSalesAgnt1 != null) {
				this.ownerLeadProfile.assignToSalesAgnt1.summary = this.getAgentNameSummary(this.ownerLeadProfile.assignToSalesAgnt1);
			}
			if (this.ownerLeadProfile.assignToSalesAgnt2 != null) {
				this.ownerLeadProfile.assignToSalesAgnt2.summary = this.getAgentNameSummary(this.ownerLeadProfile.assignToSalesAgnt2);
			}
			if (this.ownerLeadProfile.assignToSalesAgnt3 != null) {
				this.ownerLeadProfile.assignToSalesAgnt3.summary = this.getAgentNameSummary(this.ownerLeadProfile.assignToSalesAgnt3);
			}
			if (this.ownerLeadProfile.assignToSalesAgnt4 != null) {
				this.ownerLeadProfile.assignToSalesAgnt4.summary = this.getAgentNameSummary(this.ownerLeadProfile.assignToSalesAgnt4);
			}
			if (this.ownerLeadProfile.assignToMgr != null) {
				this.ownerLeadProfile.assignToMgr.summary = this.getAgentNameSummary(this.ownerLeadProfile.assignToMgr);
			}
			if (this.ownerLeadProfile.createDate != undefined && this.ownerLeadProfile.createDate != null) {
				this.ownerLeadProfile.createDate = moment.utc(this.ownerLeadProfile.createDate).format('MM/DD/YYYY');
				this.getLeadProfileAge();
			}
			if (this.ownerLeadProfile.lastUpdate != undefined && this.ownerLeadProfile.lastUpdate != null) {
				this.ownerLeadProfile.lastUpdate = moment.utc(this.ownerLeadProfile.lastUpdate).format('MM/DD/YYYY');
			}
			if (this.ownerLeadProfile.referralFeePaymentDate != undefined && this.ownerLeadProfile.referralFeePaymentDate != null) {
				this.ownerLeadProfile.referralFeePaymentDate = moment.utc(this.ownerLeadProfile.referralFeePaymentDate).format('MM/DD/YYYY');
			}
			if (this.ownerLeadProfile?.compContractExpDate) {
				this.ownerLeadProfile.compContractExpDate = moment.utc(this.ownerLeadProfile.compContractExpDate).toDate();
			}
			//this.fixDates();
			this.form1.patchValue(this.ownerLeadProfile);
		} else {
			this.ownerLeadProfileId = this.activatedRoute.snapshot.params['ownerLeadProfileId'];
			if (this.ownerLeadProfileId) {
				this.fetchOwnerLeadProfile()
			}
		}
		if (this.ownerLeadProfileId == undefined) {
			this.currentUser.summary = this.getAgentNameSummary(this.currentUser);
			this.form1.patchValue({ assignToSalesAgnt1: this.currentUser, assignToSalesAgnt2: this.currentUser, assignToSalesAgnt3: this.currentUser });
		}
		//Default make form as dirty
		this.form1.markAllAsTouched();
	}

	getAgentNameSummary(user: any) {
		let summary = "";
		if (user) {
			if (user.lastName) {
				summary = summary + user.lastName
			}
			if (user.firstName) {
				if (user.lastName) {
					summary = summary + ", " + user.firstName
				} else {
					summary = summary + user.firstName
				}
			}
			if (user.companyName) {
				summary = summary + " " + user.companyName
			}
			if (user.companyCity) {
				summary = summary + " " + user.companyCity
			}
			if (user.companyState) {
				summary = summary + " " + user.companyState
			}
			if (user.companyCountry) {
				summary = summary + " " + user.companyCountry
			}
			if (user.emailAddress) {
				summary = summary + " " + user.emailAddress
			}
			if (user.mobilePhone) {
				summary = summary + " " + user.mobilePhone
			}
		}
		return summary;
	}

	onFormDelete() {
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.ownerLeadProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.deleteRelationshipOfPropertyLeadAndOwnerLeadProfile()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	setAssignedToUserId($event) {
		this.assignedToUserId = $event['assignedToUserId'];
	}

	formAdd() {
		try {
			// stop here if form is invaliddd
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			this.ownerLeadProfileService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ownerLeadProfile = res.data.ownerProfile;
						this.doAdd.emit(this.ownerLeadProfile);
					},
					(err: any) => {
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	get emailAddress(): string {
		return this.form1.get('emailAddress')?.value;
	}

	get mobilePhone(): string {
		return this.form1.get('mobilePhone')?.value;
	}

	formUpdate() {
		this.errorList = [];
		this.errorMessages = "";
		try {
			if (this.form1.value.lastName == null || this.form1.value.lastName == undefined || this.form1.value.lastName == "") {
				this.errorList.push("FirstName is required");
			}
			if (this.form1.value.firstName == null || this.form1.value.firstName == undefined || this.form1.value.firstName == "") {
				this.errorList.push("LastName is required");
			}

			if (this.errorList.length > 0) {
				for (let i = 0; i < this.errorList.length; i++) {
					this.errorMessages += this.errorList[i] + "<br>";
				}
				if (this.errorMessages != "") {
					this.showValidationErrors = true;
					this.showValidationError = true;
				}
				return;
			}
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			this.form1.value.ownerLeadProfileId = this.ownerLeadProfileId;
			this.form1.value.propertyLeadProfiles = this.ownerLeadProfile?.propertyLeadProfiles;
			this.form1.value.compContractExpDate ? this.form1.value.compContractExpDate = this.addLocalTimeToDateTime(new Date(this.form1.value.compContractExpDate)) : null;

			console.log("this.form1", this.form1?.value?.compContractExpDate)
			this.ownerLeadProfileService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						this.formLoading = false;
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ownerLeadProfile = res.data.ownerLeadProfile;
						this.doUpdate.emit(this.ownerLeadProfile);
					},
					(err: any) => {
						// Do NOT reset formLoading on error — a 504 means the backend may
						// have already saved the update. Keep button disabled to block re-submit.
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.formLoading = false;
			this.alertService.error(error);
		}
	}

	touchOwnerLeadProfile(): void {
		if (!this.ownerLeadProfileId) return;

		const payload = { ...this.form1.value };
		payload.ownerLeadProfileId = this.ownerLeadProfileId;
		payload.propertyLeadProfiles = this.ownerLeadProfile?.propertyLeadProfiles ?? [];
		if (payload.compContractExpDate) {
			payload.compContractExpDate = this.addLocalTimeToDateTime(new Date(payload.compContractExpDate));
		}

		this.ownerLeadProfileService.update(payload).pipe(take(1)).subscribe({
			next: (res: any) => {
				const updated = res?.data?.ownerLeadProfile;
				if (updated && this.ownerLeadProfile) {
					if (updated.lastUpdate) {
						this.ownerLeadProfile.lastUpdate = moment.utc(updated.lastUpdate).format('MM/DD/YYYY');
					}
					this.doUpdate.emit(updated);
				}
			},
			error: () => {}
		});
	}

	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}

	formDelete() {
		try {
			this.ownerLeadProfileService.delete(this.ownerLeadProfile.ownerLeadProfileId)
				.subscribe(
					(res: any) => {
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.ownerLeadProfile);
					},
					(err: any) => {
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	deleteRelationshipOfPropertyLeadAndOwnerLeadProfile() {
		try {
			this.ownerLeadProfileService.deleteRelationshipOfPropertyLeadAndOwnerLeadProfile(this.ownerLeadProfile.ownerLeadProfileId)
				.subscribe(
					(res: any) => {
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.ownerLeadProfile);
					},
					(err: any) => {
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			ownerLeadProfileId: [this.ownerLeadProfileId],
			firstName: ['', Validators.required],
			lastName: ['', Validators.required],
			emailAddress: [],
			mobilePhone: [],
			subjAdrStreet: [],
			subjAdrStreet2: [],
			subjAdrCity: [],
			subjAdrState: [],
			subjAdrPostalCode: [],
			subjAdrDevelopmentName: [],
			mailAdrStreet: [],
			mailAdrStreet2: [],
			mailAdrCity: [],
			mailAdrState: [],
			mailAdrPostalCode: [],
			// mailAdrCountry: [],
			leadStatus: [1],
			probability: [],
			ownershipInterest: [],
			winReason: [],
			lossReason: [],
			assignToSalesAgnt1: [],
			assignToSalesAgnt2: [],
			assignToSalesAgnt3: [],
			subjAdrLocationDesc: [],
			customerNotes: [],
			ownershipStatus: [],
			fullName: [],
			emailAddress2: [],
			phone2: [],
			mailAdrLocationDesc: [],
			compName: [],
			compNegReason: [],
			compNegDesc: [],
			compPosDesc: [],
			compContractExpDate: [],
			compMgmtFee: [],
			currentGrossRev: [],
			propertyLeadProfiles:[]
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.ownerLeadProfile.ownerLeadProfileDate = moment(this.ownerLeadProfile.ownerLeadProfileDate).toDate();
	}

	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.findAllSummary()
					.subscribe(
						res => {
							this.properties = res.data.properties;
							return this.properties;
						},
						err => {
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				this.alertService.error(error);
			}
		}
		else {
			return (this.properties);
		}
	}


	fetchUsers() {
		if (!this.users || this.users === undefined || this.users.length < 1) {
			try {
				this.userService.findAll()
					.subscribe(
						res => {
							this.users = res.data.users;
							return this.users;
						},
						err => {
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				this.alertService.error(error);
			}
		}
		else {
			return (this.properties);
		}
	}

	formAddPropertyLead() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: "Add Property Lead Profile",
			ownerLeadProfile: this.ownerLeadProfile
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(
			OwnerPropertyComponent,
			dialogConfig
		);

		dialogRef.componentInstance.doAdd.subscribe((data) => {

			this.propertyLeadProfilesList = [];
			this.fetchPropertyLeadProfiles();

			if (this.ownerLeadProfile) {
				this.ownerLeadProfile?.propertyLeadProfiles.unshift(data);

				// no idea what this is but it is required to update the array
				this.ownerLeadProfile.propertyLeadProfiles = [...this.ownerLeadProfile?.propertyLeadProfiles];
				this.form1.patchValue({
					propertyLeadProfiles: this.ownerLeadProfile?.propertyLeadProfiles
				});
			}
			else {
				this.propertyLeadProfileObj.push(data);

				this.form1.patchValue({
					propertyLeadProfiles: this.propertyLeadProfileObj
				});
			}

			// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
			//	this.updateOwnerStmtCB(data);

			dialogRef.close();

		});
	}

	// get all property lead profiles
	fetchPropertyLeadProfiles() {
		try {
			this.propertyLeadProfileService.findAll()
				.subscribe(
					res => {
						this.propertyLeadProfilesList = res.data.propertyLeadProfiles;
						return this.propertyLeadProfilesList;
					},
					err => {
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	// get all realtor profiles
	fetchRealtorProfiles() {
		try {
			this.realtorProfileService.findAll()
				.subscribe(
					res => {
						this.realtorProfilesList = res.data.realtorProfiles;
						return this.realtorProfilesList;
					},
					err => {
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	// get all realtor profiles
	fetchOwnerLeadProfile() {
		try {
			this.ownerLeadProfileService.findById(this.ownerLeadProfileId)
				.subscribe(
					res => {
						this.ownerLeadProfile = res.data.ownerLeadProfile;
						if (this.ownerLeadProfile.assignToSalesAgnt1 != null) {
							this.ownerLeadProfile.assignToSalesAgnt1.summary = this.getAgentNameSummary(this.ownerLeadProfile.assignToSalesAgnt1);
						}
						if (this.ownerLeadProfile.assignToSalesAgnt2 != null) {
							this.ownerLeadProfile.assignToSalesAgnt2.summary = this.getAgentNameSummary(this.ownerLeadProfile.assignToSalesAgnt2);
						}
						if (this.ownerLeadProfile.assignToSalesAgnt3 != null) {
							this.ownerLeadProfile.assignToSalesAgnt3.summary = this.getAgentNameSummary(this.ownerLeadProfile.assignToSalesAgnt3);
						}
						if (this.ownerLeadProfile.assignToSalesAgnt4 != null) {
							this.ownerLeadProfile.assignToSalesAgnt4.summary = this.getAgentNameSummary(this.ownerLeadProfile.assignToSalesAgnt4);
						}
						if (this.ownerLeadProfile.assignToMgr != null) {
							this.ownerLeadProfile.assignToMgr.summary = this.getAgentNameSummary(this.ownerLeadProfile.assignToMgr);
						}
						if (this.ownerLeadProfile.createDate != undefined && this.ownerLeadProfile.createDate != null) {
							this.ownerLeadProfile.createDate = moment.utc(this.ownerLeadProfile.createDate).format('MM/DD/YYYY');
							this.getLeadProfileAge();
						}
						if (this.ownerLeadProfile.lastUpdate != undefined && this.ownerLeadProfile.lastUpdate != null) {
							this.ownerLeadProfile.lastUpdate = moment.utc(this.ownerLeadProfile.lastUpdate).format('MM/DD/YYYY');
						}
						if (this.ownerLeadProfile?.compContractExpDate) {
							this.ownerLeadProfile.compContractExpDate = moment.utc(this.ownerLeadProfile.compContractExpDate).toDate();
						}
						//this.fixDates();
						this.form1.patchValue(this.ownerLeadProfile);
					},
					err => {
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formAddRealtorProfile() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: "Add Realtor Profile",
			isDisplayOwnerProfile: true
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(
			RealtorProfileComponent,
			dialogConfig
		);

		dialogRef.componentInstance.doAddRealtor.subscribe((data) => {

			this.realtorProfilesList = [];
			this.fetchRealtorProfiles();
			this.form1.patchValue({
				realtorProfileId: data.realtorProfileId

			});

			dialogRef.close();
		});
	}

	/* On each keystroke search for the user */
	onKeyInput(event) {
		let query = event.query;
		this.findUsersWith(query);
		return this.taskUserSuggestions;
	}

	/* Search for user */
	findUsersWith(queryString: any) {
		this.userService.findUsersWithEmployeeRelationship(queryString.query).pipe(first()).subscribe(

			data => {
				this.taskUserSuggestions = [];
				this.isAgent1 = false;
				if (data.data.userSummaryList.length < 1) {
					this.isAgent1 = true;
				} else {
					data.data.userSummaryList.forEach(user => {
						user.summary = this.getAgentNameSummary(user);
					});
				}
				this.taskUserSuggestions = data.data.userSummaryList;
			},
			error => {
				this.alertService.error(error);
			},
			() => { }
		);
	}

	/* Search for user */
	findUsersWith2(queryString: any) {
		this.userService.findUsersWithEmployeeRelationship(queryString.query).pipe(first()).subscribe(

			data => {
				this.taskUserSuggestions = [];
				this.isAgent2 = false;
				if (data.data.userSummaryList.length < 1) {
					this.isAgent2 = true;
				} else {
					data.data.userSummaryList.forEach(user => {
						user.summary = this.getAgentNameSummary(user);
					});
				}
				this.taskUserSuggestions = data.data.userSummaryList;
			},
			error => {
				this.alertService.error(error);
			},
			() => { }
		);
	}

	/* Search for user */
	findUsersWith3(queryString: any) {
		this.userService.findUsersWithEmployeeRelationship(queryString.query).pipe(first()).subscribe(

			data => {
				this.taskUserSuggestions = [];
				this.isAgent3 = false;
				if (data.data.userSummaryList.length < 1) {
					this.isAgent3 = true;
				} else {
					data.data.userSummaryList.forEach(user => {
						user.summary = this.getAgentNameSummary(user);
					});
				}
				this.taskUserSuggestions = data.data.userSummaryList;
			},
			error => {
				this.alertService.error(error);
			},
			() => { }
		);
	}

	/* Search for user */
	findUsersWith4(queryString: any) {
		this.userService.findUsersWithEmployeeRelationship(queryString.query).pipe(first()).subscribe(

			data => {
				this.taskUserSuggestions = [];
				this.isAgent4 = false;
				if (data.data.userSummaryList.length < 1) {
					this.isAgent4 = true;
				} else {
					data.data.userSummaryList.forEach(user => {
						user.summary = this.getAgentNameSummary(user);
					});
				}
				this.taskUserSuggestions = data.data.userSummaryList;
			},
			error => {
				this.alertService.error(error);
			},
			() => { }
		);
	}

	/* Search for user */
	findUsersWith5(queryString: any) {
		this.userService.findUsersWithEmployeeRelationship(queryString.query).pipe(first()).subscribe(

			data => {
				this.taskUserSuggestions = [];

				this.isManager = false;
				if (data.data.userSummaryList.length < 1) {
					this.isManager = true;
				} else {
					data.data.userSummaryList.forEach(user => {
						user.summary = this.getAgentNameSummary(user);
					});
				}
				this.taskUserSuggestions = data.data.userSummaryList;
			},
			error => {
				this.alertService.error(error);
			},
			() => { }
		);
	}

	// search name of location
	changeNameFilter(name: string) {
		this.propertyLeadProfileService.search(name).then(value => {
			this.filteredNames = value.search.map((item: any) => {
				return {
					propertyLeadProfileId: item.propertyLeadProfileId,
					firstName: item.firstName,
					lastName: item.lastName,
					subjAdrDevelopmentName: item.subjAdrDevelopmentName,
					subjAdrStreet: item.subjAdrStreet,
					summary: item?.subjAdrStreet + " " + item?.subjAdrDevelopmentName + " " + item?.firstName + " " + item?.lastName + " " + item?.propertyLeadProfileId
					// subjAdrUnit: item.subjAdrUnit,
					// subjAdrCity: item.subjAdrCity,
					// subjAdrState: item.subjAdrState
				}
			});
		})
	}
	onPropertyLeadSelect(event: any) {
		this.ownerLeadProfile?.propertyLeadProfiles.push(event)
	}

	onFormDeletePropertyLeadProfile(profile: any): void {
		const index = this.ownerLeadProfile?.propertyLeadProfiles.findIndex(
			(p) => p.propertyLeadProfileId === profile.propertyLeadProfileId
		);

		if (index > -1) {
			this.ownerLeadProfile?.propertyLeadProfiles.splice(index, 1);
		}
	}

	closePopUpOfQuote() {
		this.doUpdate.emit("close");
		if (this.dialogRef) {
			this.dialogRef.close();
		}
	}


	getLeadProfileAge() {
		if (this.ownerLeadProfile?.createDate) {
			const from = moment(this.ownerLeadProfile.createDate);
			const to = moment();

			const years = to.diff(from, 'years');
			from.add(years, 'years');

			const months = to.diff(from, 'months');
			from.add(months, 'months');

			const days = to.diff(from, 'days');

			const parts: string[] = [];

			if (years > 0) {
				parts.push(`${years} year${years !== 1 ? 's' : ''}`);
			}
			if (months > 0) {
				parts.push(`${months} month${months !== 1 ? 's' : ''}`);
			}
			if (days > 0) {
				parts.push(`${days} day${days !== 1 ? 's' : ''}`);
			}

			if (parts.length === 0) {
				parts.push('New Account');
			}

			this.leadProfileAge = parts.join(' , ');
		}
	}
}
